import { render, staticRenderFns } from "./errAuthModal.vue?vue&type=template&id=4f2a53d5&scoped=true"
import script from "./errAuthModal.vue?vue&type=script&lang=js"
export * from "./errAuthModal.vue?vue&type=script&lang=js"
import style0 from "./errAuthModal.vue?vue&type=style&index=0&id=4f2a53d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a53d5",
  null
  
)

export default component.exports